(ns app.front.ui.error-boundary
  (:require [core.front.event :refer [<sub]]
            [reagent.core :as r]))

(def error-class "bg-red-600 text-white")

(defn error-boundary
  "A wrapper for React's componentDidCatch. Use this to create error boundaries."
  [& _]
  (let [error          (r/atom nil)
        error-visible? (r/atom false)
        tr             (<sub [:tr])]
    (r/create-class
      {:display-name        "ErrorBoundary"
       :data-cy             "error-boundary"
       :component-did-catch (fn [err info]
                              (reset! error [err info]))
       :reagent-render      (fn [& children]
                              (let [state (if (nil? @error)
                                            :ok
                                            (if @error-visible?
                                              :error
                                              :message))]
                                (case state
                                  :ok (into [:<>] children)
                                  :error (let [[_ info] @error] [:pre.p-8 {:class error-class} [:code (pr-str info)]])
                                  :message [:div.p-8 {:class error-class}
                                            [:button.text-lg.text-white.border-0.bg-transparent
                                             {:on-click #(reset! error-visible? true)}
                                             (tr [:error/something-went-wrong])]])))})))
